import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const FineBannar = () => {
    return (
        <>
            <div className='dfl_fine_jwelery_banner'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row>
                        <Col sm={12} md={6} lg={6}>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                            <div className='banner_cotntent'>
                                <h1>Fine <br /> <span>jewellery </span></h1>
                                <p>DFL offers a stunning collection of fine diamond jewellery that is perfect for every occasion. Choose from our handpicked selection of exquisite pieces or let our diamond experts assist you create a one-of-a-kind piece. With jewellery to fit any budget and taste make every occasion special and unforgettable.</p>
                                <NavLink to="/jewellery/fine-jewellery">Shop jewellery </NavLink>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default FineBannar